import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=5b82f5d2"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports